type HamburgerMenu = {
  active: boolean;
  onClick: () => void;
};

export default function HamburgerMenu({ active, onClick }: HamburgerMenu) {
  return (
    <button className={`McButton ${active ? "active" : ""} `} onClick={onClick}>
      <b></b>
      <b></b>
      <b></b>
    </button>
  );
}
